import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface ISrecPriceCurveApiClient {
    getSrecPriceCurves(): ng.IPromise<Models.CostCalculation.MarketAssumedValuesModel.SrecPriceCurves[]>;
    getSrecPriceIntervalsBySrecPriceCurve(code: string): ng.IPromise<Models.CostCalculation.MarketAssumedValuesModel.ISrecPriceCurves>;
    updateSrecPriceCurve(srecPriceCurvesModel: Models.CostCalculation.MarketAssumedValuesModel.ISrecPriceCurves): ng.IPromise<Models.BaseApiResponse.BaseApiResponse>;
    updateSrecPriceCurveName(srecPriceCurvesModel: Models.CostCalculation.MarketAssumedValuesModel.ISrecPriceCurves): ng.IPromise<Models.BaseApiResponse.BaseApiResponse>;
    cloneSrecPriceCurve(srecPriceCurvesRequest: Models.CostCalculation.CloneSrecPriceCurveRequest.ICloneSrecPriceCurveRequest): ng.IPromise<Models.CostCalculation.MarketAssumedValuesModel.ICloneSrecPriceCurveResponse>;
}

export class SrecPriceCurveApiClient implements ISrecPriceCurveApiClient {
    public prefix: string;

    public static $inject = ['igs.apiClientService'];

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
        this.prefix = "SrecPriceCurves";
    }

    public getSrecPriceCurves = (): ng.IPromise<Models.CostCalculation.MarketAssumedValuesModel.SrecPriceCurves[]> => {
        var url = `${this.prefix}/GetSrecPriceCurves`;
        return this.igsApiClientService.get(url);
    }

    public getSrecPriceIntervalsBySrecPriceCurve = (code: string): ng.IPromise<Models.CostCalculation.MarketAssumedValuesModel.ISrecPriceCurves> => {
        var url = `${this.prefix}/GetSrecPriceIntervalsBySrecPriceCurve/${code}`;
        return this.igsApiClientService.get(url);
    }

    public updateSrecPriceCurve = (srecPriceCurvesModel: Models.CostCalculation.MarketAssumedValuesModel.ISrecPriceCurves): ng.IPromise<Models.BaseApiResponse.BaseApiResponse> => {
        var url = `${this.prefix}/UpdateSrecPriceCurve`;
        return this.igsApiClientService.post(url, srecPriceCurvesModel);
    }

    public updateSrecPriceCurveName = (srecPriceCurvesModel: Models.CostCalculation.MarketAssumedValuesModel.ISrecPriceCurves): ng.IPromise<Models.BaseApiResponse.BaseApiResponse> => {
        var url = `${this.prefix}/UpdateSrecPriceCurveName`;
        return this.igsApiClientService.post(url, srecPriceCurvesModel);
    }

    public cloneSrecPriceCurve = (srecPriceCurvesRequest: Models.CostCalculation.CloneSrecPriceCurveRequest.ICloneSrecPriceCurveRequest): ng.IPromise<Models.CostCalculation.MarketAssumedValuesModel.ICloneSrecPriceCurveResponse> => {
        var url = `${this.prefix}/CloneSrecPriceCurve`;
        return this.igsApiClientService.post(url, srecPriceCurvesRequest);
    }

}